import React, { Component } from 'react'
import { DeleteIcon, LoadingIcon } from '@myxplor/icons'
import { FormButton } from '@myxplor/forms'
// import RemoteRequest from '../../../remote-request'

export class GovMessageRemove extends Component {
  submit() {
    this.props.remote_request.submit(this.props.apiEndPoint, {
      method: 'DELETE',
      jsonAPI: true,
    })
  }

  componentDidUpdate() {
    const { data } = this.props.remote_request.state

    if (data && data.success) {
      this.props.afterDelete()
    }
  }

  render() {
    const { loading } = this.props.remote_request.state

    return loading ? (
      <LoadingIcon loading />
    ) : (
      <FormButton right onClick={this.submit.bind(this)}>
        <DeleteIcon title="Delete this message" />
      </FormButton>
    )
  }
}

// export default RemoteRequest(GovMessageRemove)

// Obviously remove this when we are ready to remove messages
const NoDeleteJustYet = () => null

export default NoDeleteJustYet



// WEBPACK FOOTER //
// ./src/ui/gov-messages/views/delete-message.jsx